import type { OnChangeFn, PaginationState, SortingState } from "@tanstack/react-table";
import { useState } from "react";

export const useServerTableState = (initialPageSize: number, initialSorting: SortingState = []) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: initialPageSize,
  });
  const [sorting, setSorting] = useState<SortingState>(initialSorting);

  const onPaginationChange: OnChangeFn<PaginationState> = (updater) => {
    setPagination((previous) => {
      const next = typeof updater === "function" ? updater(previous) : updater;
      return next.pageSize === previous.pageSize ? next : { ...next, pageIndex: 0 };
    });
  };

  const onSortingChange: OnChangeFn<SortingState> = (updater) => {
    setSorting((previous) => (typeof updater === "function" ? updater(previous) : updater));
    setPagination((previous) => ({ ...previous, pageIndex: 0 }));
  };

  return { pagination, onPaginationChange, sorting, onSortingChange };
};
